import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';

export interface Payload {
  sequenceId: string;
  sequenceTitle: string;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenProposeSequenceModal = () => useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseProposeSequenceModal = () => useSetAtom(closeModalAtom);

export const useOpenProposeSequenceModal = () => useSetAtom(payloadAtom);

export const useGetProposeSequenceModalPayload = () =>
  useAtomValue(payloadAtom);
